import { z } from "zod";
import { useApiQuery } from "../../../services/api";

export function useCheckEmailExistsQuery(email: string | null) {
  const validEmail =
    email !== null && z.email().safeParse(email).success ? email : null;
  const query = useApiQuery(
    "/webapp/public/auth/check-email",
    validEmail === null
      ? false
      : { query: { email: validEmail }, staleTime: 60_000 }
  );

  return {
    data: query.state === "success" ? query.body : undefined,
    isLoading: query.state === "pending",
  };
}
